var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCounselling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F2FAF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0001 20.16C30.9401 20.15 30.8701 20.15 30.8101 20.16C29.4301 20.11 28.3301 18.98 28.3301 17.58C28.3301 16.15 29.4801 15 30.9101 15C32.3401 15 33.4901 16.16 33.4901 17.58C33.4801 18.98 32.3801 20.11 31.0001 20.16Z",
    stroke: "#009A56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9699 27.4402C31.3399 27.6702 32.8499 27.4302 33.9099 26.7202C35.3199 25.7802 35.3199 24.2402 33.9099 23.3002C32.8399 22.5902 31.3099 22.3502 29.9399 22.5902",
    stroke: "#009A56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.97 20.16C19.03 20.15 19.1 20.15 19.16 20.16C20.54 20.11 21.64 18.98 21.64 17.58C21.64 16.15 20.49 15 19.06 15C17.63 15 16.48 16.16 16.48 17.58C16.49 18.98 17.59 20.11 18.97 20.16Z",
    stroke: "#009A56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 27.4402C18.6299 27.6702 17.1199 27.4302 16.0599 26.7202C14.6499 25.7802 14.6499 24.2402 16.0599 23.3002C17.1299 22.5902 18.6599 22.3502 20.0299 22.5902",
    stroke: "#009A56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 27.6302C24.9401 27.6202 24.8701 27.6202 24.8101 27.6302C23.4301 27.5802 22.3301 26.4502 22.3301 25.0502C22.3301 23.6202 23.4801 22.4702 24.9101 22.4702C26.3401 22.4702 27.4901 23.6302 27.4901 25.0502C27.4801 26.4502 26.3801 27.5902 25.0001 27.6302Z",
    stroke: "#009A56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0902 30.7804C20.6802 31.7204 20.6802 33.2603 22.0902 34.2003C23.6902 35.2703 26.3102 35.2703 27.9102 34.2003C29.3202 33.2603 29.3202 31.7204 27.9102 30.7804C26.3202 29.7204 23.6902 29.7204 22.0902 30.7804Z",
    stroke: "#009A56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounselling);
export default __webpack_public_path__ + "static/media/counselling.bfe49dfd5faf0057762359c1660f792c.svg";
export { ForwardRef as ReactComponent };